import React, { useEffect, useState } from "react";
import { Modal, ConfigProvider } from "antd";
import useScrollLock from "../../hooks/useScrollLock";
import OrderPaymentCommonComponent from "../restaurants/orders/OrderPaymentCommonComponent";
import { DISCOUNT_TYPES } from "../../constant/constants";

const discountTypes = [DISCOUNT_TYPES[1], DISCOUNT_TYPES[0]];
/**
 * This modal will appear for two actions one is accepting order and another is to receive payment.
 *
 * Accepting order has two main cases (order status in pending):
 * Case 1: The order is an online paid order. It will accept with cooking time.
 * Case 2: The order is unpaid means placed as counter payment or pay after eating. It will accept order as payment mode or pay later mode with cooking time
 *
 * Receive Payment
 * After accepting order with pay later mode, it will only appear to receive payment at any order status except pending
 *
 * There are some logics inside the modal
 *
 * @param {*} param0
 * @returns
 */
function OrderPaymentModal({ openModal, params, cookingTime = "30", shouldShowCookingTime = true }) {
  const [defaultDiscountTypes, setDefaultDiscountTypes] = useState(discountTypes);

  // Lock scroll when modal is open
  useScrollLock(openModal);

  const handleCancel = () => {
    params.onCancel();
  };

  const onHandleActionButtons = (actionType, extraValues) => {
    if (actionType === 'PAYMENT_DONE') {
      params.onFinish(extraValues);
      return;
    }

    if (['PAYMENT_CANCEL', 'GUEST_BILL'].includes(actionType)) {
      params.onCancel();
    }
  }


  const handleOk = () => {
    params.onCancel();
  };

  // when only discount not applicable food ordered discountApplicablePrice will be zero and in that case percent discount will not be available
  useEffect(() => {
    if (params.order?.discountApplicablePrice && params.order.discountApplicablePrice > 0) {
      setDefaultDiscountTypes(discountTypes);
    } else {
      setDefaultDiscountTypes([DISCOUNT_TYPES[0]])
    }
  }, [params.order])

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        width={550}
        maskClosable={false}
        open={openModal}
        onOk={handleOk}
        onCancel={handleCancel}
        title={`Process Order (${params.order.order_id})`}
        footer={null}
        styles={{ body: { paddingTop: "0px" } }}
      >
        <OrderPaymentCommonComponent 
          order={params.order}
          cookingTime={cookingTime}
          onPaymentParentActionHandler={onHandleActionButtons}
          shouldShowCookingTime={shouldShowCookingTime}
          defaultDiscountTypes={defaultDiscountTypes}
          onCloseModal={openModal ? true: 'xyz'}
        />
      </Modal>
    </ConfigProvider>
  );
}

export default OrderPaymentModal;
